module.exports = __webpack_public_path__ + "static/img/RWB-48V5A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RWB-48V5A.png
// module id = 3kGz
// module chunks = 0